/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ======================================================================
     QUICK ADD : AJOUT AU PANIER SANS REDIRECTION

     Deux comportements du theme nous genent ici :

     1. `SearchPopdown` ferme la recherche sur tout clic dans <body> hors du
        popdown, or le theme deplace la modale du quick add dans <body> :
        chaque clic dedans fermait donc la recherche derriere elle.

     2. La boutique est reglee sur `cart_type: page` : apres un ajout reussi,
        `Cart.addToCart` (theme.js) renvoie vers /cart. On prend donc la main
        sur les ajouts lances depuis un bouton d'ajout rapide, partout ou il
        existe : recherche rapide, grilles de collection, upsells produit,
        siblings. La fiche produit garde le comportement du theme.

     Exception : la page panier et le tiroir panier, ou le rechargement est
     justement ce qui affiche la ligne ajoutee. On y laisse le theme faire.
     ====================================================================== */

  /**
   * Vrai si ce bouton/formulaire doit garder le comportement du theme.
   */
  function isCartContext(element) {
    return Boolean(
      document.body.classList.contains('template-cart') || (element && element.closest('cart-drawer'))
    );
  }

  /**
   * Ajout au panier en AJAX, sans redirection.
   * Retourne une promesse resolue avec true si le produit a ete ajoute.
   */
  function ajaxAddToCart(form, button, errorHolder) {
    if (!form.checkValidity()) {
      form.reportValidity();
      return Promise.resolve(false);
    }

    if (errorHolder) errorHolder.textContent = '';

    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    return fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return {ok: response.ok, data: data};
        });
      })
      .then(function (result) {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }

        if (!result.ok) {
          if (errorHolder) {
            errorHolder.textContent = result.data.description || result.data.message || '';
          }
          return false;
        }

        if (button) button.classList.add('is-added');

        // <cart-count> dans le header ecoute theme:cart:change
        return fetch(window.theme.routes.cart_url + '.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: {cartCount: cart.item_count},
              })
            );
            return true;
          })
          .catch(function () {
            return true;
          });
      })
      .catch(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
        if (errorHolder) {
          errorHolder.textContent = 'Une erreur est survenue, merci de reessayer.';
        }
        return false;
      });
  }

  /**
   * Produits a plusieurs variantes : envoi du formulaire dans la modale.
   * Listener en capture sur le <dialog>, donc avant celui que <product-form>
   * pose sur le formulaire ; le stopPropagation coupe le parcours du theme.
   */
  function onModalSubmit(event) {
    var form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (isCartContext(form)) return;

    event.preventDefault();
    event.stopPropagation();

    var modal = form.closest('dialog[data-quick-add-modal]');
    var button = form.querySelector('[data-add-to-cart]');
    var errorHolder = modal ? modal.querySelector('[data-cart-error-message]') : null;

    if (button && button.hasAttribute('disabled')) return;

    ajaxAddToCart(form, button, errorHolder).then(function (added) {
      if (!added || !modal) return;

      // Laisse voir l'etat "ajoute" avant de refermer la popup
      setTimeout(function () {
        modal.dispatchEvent(new CustomEvent('theme:modal:close', {bubbles: false}));
      }, 600);
    });
  }

  /**
   * Produits a variante unique : le bouton d'ajout rapide ajoute directement
   * au panier. Listener en capture sur document, donc avant celui que
   * <quick-add-product> pose sur le bouton lui-meme.
   */
  function onQuickAddClick(event) {
    var button = event.target.closest('[data-add-to-cart]');
    if (!button || !button.closest('quick-add-product')) return;
    if (button.hasAttribute('disabled') || isCartContext(button)) return;

    var form = button.form || button.closest('form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    ajaxAddToCart(form, button, button.querySelector('[data-message-error]')).then(function (added) {
      if (!added) return;

      setTimeout(function () {
        button.classList.remove('is-added');
      }, 2000);
    });
  }

  document.addEventListener('click', onQuickAddClick, true);

  document.addEventListener('theme:quick-add:open', function () {
    document.querySelectorAll('dialog[data-quick-add-modal][open]').forEach(function (modal) {
      if (modal.dataset.searchQuickAddBound === 'true') return;
      modal.dataset.searchQuickAddBound = 'true';

      // 1. garder la recherche ouverte pendant l'utilisation de la modale
      modal.addEventListener('click', function (event) {
        if (document.querySelector('header-search-popdown.is-open')) {
          event.stopPropagation();
        }
      });

      // 2. ajout au panier sans redirection
      modal.addEventListener('submit', onModalSubmit, true);
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
